export const NILE_GRID_HEAD_ITEM = "NILE-GRID-HEAD-ITEM";